//import axios from "axios";
import ApiService from "@/core/services/api.service";
// action types
export const OBTENER_UNIDADES_EJECUTORAS = "obtenerUnidadesEjecutoras";
export const OBTENER_UNIDADES_EJECUTORAS_INSTITUCION = "obtenerUnidadesEjecutorasPorInstitucion";

//Obtener de esquema externo
export const OBTENER_UNIDADES_EJECUTORAS_ENTIDAD = "obtenerUnidadesEjecutorasPorEntidad";

export const OBTENER_UNIDAD_EJECUTORA = "obtenerUnidadEjecutora";
export const REGISTRAR_UNIDAD_EJECUTORA = "registrarUnidadEjecutora";
export const ACTUALIZAR_UNIDAD_EJECUTORA = "actualizarUnidadEjecutora";

// mutation types
export const SET_UNIDADES_EJECUTORAS = "setUniadesEjecutoras";
export const SET_UNIDAD_EJECUTORA = "setUniadEjecutora";

const state = {
  unidadesEjecutoras: [],
  unidadEjecutora: []
};

const getters = {
  obtnenerunidadesEjecutoras(state) {
    return state.unidadesEjecutoras;
  }
};


const actions = {
  async [OBTENER_UNIDADES_EJECUTORAS](context) {
    return new Promise(resolve => {

      ApiService.query("apiconsume/obtener?endpoint=UnidadesEjecutoras", "")
        .then(({ data }) => {
          context.commit(SET_UNIDADES_EJECUTORAS, data.data);

          resolve(data);
        })
        .catch(error => {
          resolve({
              status: 400,
              message: error.message
          });

          //context.commit(SET_ERROR, response.data.errors);
        });
    });
  },


  //Obtener unidades ejecutoras por institucion
  async [OBTENER_UNIDADES_EJECUTORAS_INSTITUCION](context, institucionId){
    return new Promise(resolve => {

      ApiService.query(`apiconsume/obtener?endpoint=UnidadesEjecutoras/all/1/${institucionId}`)
        .then(({ data }) => {
          context.commit(SET_UNIDADES_EJECUTORAS, data.data);

          resolve(data);
        })
        .catch(error => {
          resolve({
              status: 400,
              message: error.message
          });

          //context.commit(SET_ERROR, response.data.errors);
        });
    });

  },


    //Obtener unidades ejecutoras por institucion
    async [OBTENER_UNIDADES_EJECUTORAS_ENTIDAD](context, entidadId){
      return new Promise(resolve => {
  
        ApiService.query(`apiconsume/obtener?endpoint=UnidadesEjecutoras/all/Entidad/1/${entidadId}`)
          .then(({ data }) => {
            context.commit(SET_UNIDADES_EJECUTORAS, data.data);
  
            resolve(data);
          })
          .catch(error => {
            resolve({
                status: 400,
                message: error.message
            });
  
            //context.commit(SET_ERROR, response.data.errors);
          });
      });
  
    },
  

  async [OBTENER_UNIDAD_EJECUTORA](context, id) {
    return new Promise(resolve => {

      //context.commit(SET_UNIDAD_EJECUTORA, unidadEjecutora);

      

      
      ApiService.query(`apiconsume/edit/${id}?endpoint=UnidadesEjecutoras/`)
        .then(({ data }) => {
          context.commit(SET_UNIDAD_EJECUTORA, data.data);
          //console.log(this.unidadesEjecutoras)
          resolve(data);
        })
        .catch(error => {
          resolve({
          status: 500,
          message:error,
          others: id,
          data: error
        });
        });
    });
  },

 

  /**
   * Registrar una institución
   * @param {*} context
   * @param {*} datosunidadEjecutora
   * @returns
   */
  async [REGISTRAR_UNIDAD_EJECUTORA](context, datosunidadEjecutora) {
    //console.log(datosEmpresa)
    return new Promise(resolve => {
      ApiService.post(
        `apiconsume/create?endpoint=UnidadesEjecutoras`,
        datosunidadEjecutora
      )
        .then(({ data }) => {
          context.commit(SET_UNIDAD_EJECUTORA, data.data);
          resolve(data);
        })
        .catch(error => {
          resolve({
              status: 400,
              message: error.message
          });
        });
    });
  },

  async [ACTUALIZAR_UNIDAD_EJECUTORA](context, datos) {
    let id = datos.id;

    return new Promise(resolve => {
      ApiService.update(
        `apiconsume/update/${id}?endpoint=UnidadesEjecutoras/`,
        datos
      )
        .then(({ data }) => {
          context.commit(SET_UNIDAD_EJECUTORA, data.data);
          resolve(data);
        })
        .catch(error => {
          resolve({
              status: 400,
              message: error.message
          });
        });
    });
  }
};

const mutations = {
  [SET_UNIDADES_EJECUTORAS](state, data) {
    state.unidadesEjecutoras = data;
  },

  [SET_UNIDAD_EJECUTORA](state, data) {
    state.unidadEjecutora = data;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
